import { useState } from 'react'

import { useUnsafeEffect } from 'modules/core/hooks/useEffect'

import { ChildrenLoading } from 'modules/finance/components/FinancialWorkspace/components/Table/table/NestedRows/ChildrenLoading'
import { BasicRow } from 'modules/finance/components/FinancialWorkspace/components/Table/table/Row/BasicRow'
import {
  InsightTableGroupBy,
  PaginatedTableItem,
} from 'modules/finance/components/FinancialWorkspace/types/table'
import { useFinanceResource } from 'modules/finance/components/FinancialWorkspaceEmployeeCosts/hooks/useFinanceResource'

import { CustomChildrenProps } from './props'

export const LazyExpenses = ({ id, level, groupBy, headerLength }: CustomChildrenProps) => {
  const [children, setChildren] = useState<PaginatedTableItem[] | undefined>()

  const { onLazyChildren } = useFinanceResource({
    financeType: 'expense',
    resource: { type: groupBy, id: Number(id) },
    childrenType: InsightTableGroupBy.CustomCategory,
  })

  useUnsafeEffect(() => {
    if (!children) {
      onLazyChildren(id).then(({ data }) => {
        setChildren(data.sort((a, b) => a?.label?.localeCompare(b?.label ?? '') ?? 0))
      })
    }
  }, [id, children])

  if (!children) return <ChildrenLoading level={level} />

  return children.map((data, index) => (
    <BasicRow
      level={level}
      data={data.data}
      title={data.label}
      key={`${id}-${index}`}
      headerCount={headerLength}
      comparisonData={data.comparisonData}
    />
  ))
}
